// @generated by protoc-gen-es v2.2.3
// @generated from file creativefabrica/payments/v1/types.proto (package creativefabrica.payments.v1, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, tsEnum } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file creativefabrica/payments/v1/types.proto.
 */
export const file_creativefabrica_payments_v1_types = /*@__PURE__*/
  fileDesc("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");

/**
 * Describes the message creativefabrica.payments.v1.Payment.
 * Use `create(PaymentSchema)` to create a new message.
 */
export const PaymentSchema = /*@__PURE__*/
  messageDesc(file_creativefabrica_payments_v1_types, 0);

/**
 * Describes the message creativefabrica.payments.v1.User.
 * Use `create(UserSchema)` to create a new message.
 */
export const UserSchema = /*@__PURE__*/
  messageDesc(file_creativefabrica_payments_v1_types, 1);

/**
 * Describes the message creativefabrica.payments.v1.BillingDetails.
 * Use `create(BillingDetailsSchema)` to create a new message.
 */
export const BillingDetailsSchema = /*@__PURE__*/
  messageDesc(file_creativefabrica_payments_v1_types, 2);

/**
 * Describes the message creativefabrica.payments.v1.Address.
 * Use `create(AddressSchema)` to create a new message.
 */
export const AddressSchema = /*@__PURE__*/
  messageDesc(file_creativefabrica_payments_v1_types, 3);

/**
 * Describes the message creativefabrica.payments.v1.PaymentCurrency.
 * Use `create(PaymentCurrencySchema)` to create a new message.
 */
export const PaymentCurrencySchema = /*@__PURE__*/
  messageDesc(file_creativefabrica_payments_v1_types, 4);

/**
 * Describes the message creativefabrica.payments.v1.PaymentLineItem.
 * Use `create(PaymentLineItemSchema)` to create a new message.
 */
export const PaymentLineItemSchema = /*@__PURE__*/
  messageDesc(file_creativefabrica_payments_v1_types, 5);

/**
 * Describes the message creativefabrica.payments.v1.PaymentTotals.
 * Use `create(PaymentTotalsSchema)` to create a new message.
 */
export const PaymentTotalsSchema = /*@__PURE__*/
  messageDesc(file_creativefabrica_payments_v1_types, 6);

/**
 * Describes the message creativefabrica.payments.v1.Intent.
 * Use `create(IntentSchema)` to create a new message.
 */
export const IntentSchema = /*@__PURE__*/
  messageDesc(file_creativefabrica_payments_v1_types, 7);

/**
 * Describes the enum creativefabrica.payments.v1.SubscriptionType.
 */
export const SubscriptionTypeSchema = /*@__PURE__*/
  enumDesc(file_creativefabrica_payments_v1_types, 0);

/**
 * @generated from enum creativefabrica.payments.v1.SubscriptionType
 */
export const SubscriptionType = /*@__PURE__*/
  tsEnum(SubscriptionTypeSchema);

/**
 * Describes the enum creativefabrica.payments.v1.SubscriptionTypeUpgrade.
 */
export const SubscriptionTypeUpgradeSchema = /*@__PURE__*/
  enumDesc(file_creativefabrica_payments_v1_types, 1);

/**
 * @generated from enum creativefabrica.payments.v1.SubscriptionTypeUpgrade
 */
export const SubscriptionTypeUpgrade = /*@__PURE__*/
  tsEnum(SubscriptionTypeUpgradeSchema);

/**
 * Describes the enum creativefabrica.payments.v1.AvailablePaymentMethodType.
 */
export const AvailablePaymentMethodTypeSchema = /*@__PURE__*/
  enumDesc(file_creativefabrica_payments_v1_types, 2);

/**
 * @generated from enum creativefabrica.payments.v1.AvailablePaymentMethodType
 */
export const AvailablePaymentMethodType = /*@__PURE__*/
  tsEnum(AvailablePaymentMethodTypeSchema);

/**
 * Describes the enum creativefabrica.payments.v1.BillingPeriod.
 */
export const BillingPeriodSchema = /*@__PURE__*/
  enumDesc(file_creativefabrica_payments_v1_types, 3);

/**
 * @generated from enum creativefabrica.payments.v1.BillingPeriod
 */
export const BillingPeriod = /*@__PURE__*/
  tsEnum(BillingPeriodSchema);

/**
 * Describes the enum creativefabrica.payments.v1.IntentType.
 */
export const IntentTypeSchema = /*@__PURE__*/
  enumDesc(file_creativefabrica_payments_v1_types, 4);

/**
 * @generated from enum creativefabrica.payments.v1.IntentType
 */
export const IntentType = /*@__PURE__*/
  tsEnum(IntentTypeSchema);

/**
 * Describes the enum creativefabrica.payments.v1.AvailableCurrencyCode.
 */
export const AvailableCurrencyCodeSchema = /*@__PURE__*/
  enumDesc(file_creativefabrica_payments_v1_types, 5);

/**
 * @generated from enum creativefabrica.payments.v1.AvailableCurrencyCode
 */
export const AvailableCurrencyCode = /*@__PURE__*/
  tsEnum(AvailableCurrencyCodeSchema);

/**
 * Describes the enum creativefabrica.payments.v1.PaymentStatus.
 */
export const PaymentStatusSchema = /*@__PURE__*/
  enumDesc(file_creativefabrica_payments_v1_types, 6);

/**
 * @generated from enum creativefabrica.payments.v1.PaymentStatus
 */
export const PaymentStatus = /*@__PURE__*/
  tsEnum(PaymentStatusSchema);

